import React from 'react';
import {injectIntl} from "react-intl";
import LabeledText from "../../common/text/LabeledText";
import {connect} from "react-redux";

class Safe extends React.Component {

  render() {
    const {intl: {formatMessage}, safe, onClick, canWrite} = this.props;

    return (
      <div>
        {safe &&
          <LabeledText label={'safe.number'} text={safe}/>
        }

        {canWrite &&
          (safe ?
            <button onClick={onClick} type="primary" className="btn btn-sm btn-primary" style={{'marginTop': '1rem'}}>
              {formatMessage({id: 'appointment.detail.reception.change-safe'})}
            </button>
            :
            <button onClick={onClick} type="primary" className="btn btn-sm btn-primary" style={{'marginTop': '1rem'}}>
              {formatMessage({id: 'appointment.detail.reception.assign-safe'})}
            </button>
          )
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  fetchRentalReporting: state.fetchRentalReporting,
  fetchRentalContract: state.fetchRentalContract
});

export default connect(
  mapStateToProps,
  null
)(injectIntl(Safe))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/reception/Safe.js